var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons426538(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M87,10L63.7,31.7v6.2h-9.5L31,59.6V246h138v-5.6l18.1-16.1h5.1v-6.2h9.5v-5.6l18.2-16.1h5.1V10H87z M137,170.2h-22.9V193H85.7v-22.8H62.8v-28.6h22.8v-22.8h28.5v22.8h22.9L137,170.2L137,170.2z M186.1,192.3v0.8v2v1.3v1.6v18.4v0.8v0.8v2.7l-0.2,0.2l-3.7,3.3L169,236.1v-11.8v-3.3v-2.9v-0.8v-0.8v-20.1v-3.3v-19.6v-2.9v-2.9V59.6H93.6h-2h-1.3h-0.7H87H65.4h-0.8h-0.8h-6.2h-3.3H42.1l0.8-0.8l0.8-0.8l8.9-8.7l0.8-0.8l0.8-0.8l2.3-2.3l0.9-0.9l0.1-0.1h6.2h0.8h0.8H79h2h2h4h3.3h95.8L186.1,192.3L186.1,192.3z M218.8,192.9l-0.2,0.2l-3.7,3.3l-13.2,11.8v-11.8v-3.3V31.7H90.3H87H74.8l0.8-0.8l0.8-0.8l8.9-8.7l0.8-0.8l0.8-0.8l2.4-2.3l0.9,0v-0.9l0.1-0.1h128.5L218.8,192.9L218.8,192.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons426538);
export default __webpack_public_path__ + "static/media/icons_426538.54cc37d1684c92f03aaa761693e170af.svg";
export { ForwardRef as ReactComponent };